import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const contracts = (state = initialState.contracts, action) => {
  switch (action.type) {
    case types.LOAD_CONTRACT_SUCCESS:
      return action.contracts;

    case types.CREATE_CONTRACT_SUCCESS:
      return [...state, { ...action.contract }];

    case types.UPDATE_CONTRACT_SUCCESS:
      return [
        ...state.filter((cont) => cont._id !== action.contract._id),
        { ...action.contract }
      ];

    case types.DELETE_CONTRACT_SUCCESS:
      return [...state.filter((cont) => cont._id !== action.contractId)];

    default:
      return state;
  }
};

export const contractsByCustomer = (
  state = initialState.contractsByCustomer,
  action
) => {
  switch (action.type) {
    case types.LOAD_CONTRACT_BY_CUSTOMER_SUCCESS:
      return action.contractsByCustomer;
    default:
      return state;
  }
};

export const contract = (state = initialState.contract, action) => {
  switch (action.type) {
    case types.GET_CONTRACT_SUCCESS:
      return action.contract;
    case types.UPDATE_CONTRACT_SUCCESS:
      return action.contract;
    case types.RESET_CONTRACT_SUCCESS:
      return {};

    default:
      return state;
  }
};

export const savingContract = (state = initialState.savingContract, action) => {
  switch (action.type) {
    case types.SAVING_CONTRACT:
      return action.savingContract;

    default:
      return state;
  }
};

export const loadingContract = (
  state = initialState.loadingContract,
  action
) => {
  switch (action.type) {
    case types.LOADING_CONTRACT:
      return action.loadingContract;

    default:
      return state;
  }
};

export const contractToDelete = (
  state = initialState.contractToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_CONTRACT_ID:
      return action.contractToDelete;

    default:
      return state;
  }
};

export const contractPOToDelete = (
  state = initialState.contractPOToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_CONTRACT_PO_ID:
      return action.contractPOToDelete;

    default:
      return state;
  }
};

export const contractNoteToDelete = (
  state = initialState.contractNoteToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_CONTRACT_NOTE_ID:
      return action.contractNoteToDelete;

    default:
      return state;
  }
};

export const itmsContracts = (state = initialState.itmsContracts, action) => {
  switch (action.type) {
    case types.LOAD_ITMS_CONTRACTS_SUCCESS:
      return action.contracts;

    default:
      return state;
  }
};
